import React, {
  FC,
} from 'react';
import SquadSemiBoldText from '../../../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../../../components/Text/PingFangMediumText';
import { GreenQuestion } from '../../../../../../../../assets/svg-image/common';
import SquadRegularText from '../../../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../../../components/Text/PingFangRegularText';

const QuestionIcon: FC<Props> = ({
  isEnglish,
  showQuestion,
  setShowQuestion,
}) => {
  return (
    <div>
      <div
        style={{ marginLeft: 9, width: 26, height: 26, alignItems: 'center' }}
        onClick={() => setShowQuestion(!showQuestion)}
      >
        <img src={GreenQuestion} style={{ marginTop: 4, width: 16, height: 16 }} />
      </div>

      {
        showQuestion && (
          <div style={{ position: 'absolute' }}>
            <div style={{ width: 23, height: 23, transform: 'rotate(45deg)', backgroundColor: '#F3F3F3' }} />
            <div style={{ width: 285, backgroundColor: '#F3F3F3', paddingTop: 17, paddingBottom: 17, paddingLeft: 25, paddingRight: 25, borderRadius: 8, marginLeft: -250, marginTop: -15 }}>
              {
                isEnglish ? (
                  <SquadRegularText fontSize={15} lineHeight={17} textAlign={'center'}>
                    Regular lockers are perfect for one or two small items.
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={15} lineHeight={20} textAlign={'center'}>
                    普通柜子适合一个或者两个小物品。
                  </PingFangRegularText>
                )
              }
              {
                isEnglish ? (
                  <SquadSemiBoldText fontSize={15} lineHeight={17} textAlign={'center'}>
                    D:318mm W:399mm H:193mm
                  </SquadSemiBoldText>
                ) : (
                  <PingFangMediumText fontSize={15} lineHeight={17} textAlign={'center'}>
                    深：<SquadSemiBoldText fontSize={15} lineHeight={17} isSpan={true}>318mm</SquadSemiBoldText> 宽：<SquadSemiBoldText fontSize={15} lineHeight={17} isSpan={true}>399mm</SquadSemiBoldText> 高：<SquadSemiBoldText fontSize={15} lineHeight={17} isSpan={true}>193mm</SquadSemiBoldText>
                  </PingFangMediumText>
                )
              }

              {
                isEnglish ? (
                  <SquadRegularText fontSize={15} lineHeight={17} textAlign={'center'} marginTop={15}>
                    Tall lockers are perfect for multiple items that are tall.
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={15} lineHeight={17} textAlign={'center'} marginTop={15}>
                    大型柜子适合放多个较大的物品。
                  </PingFangRegularText>
                )
              }
              {
                isEnglish ? (
                  <SquadSemiBoldText fontSize={15} lineHeight={17} textAlign={'center'}>
                    D:420mm W:400mm H:430mm
                  </SquadSemiBoldText>
                ) : (
                  <PingFangMediumText fontSize={15} lineHeight={17} textAlign={'center'}>
                    深：<SquadSemiBoldText fontSize={15} lineHeight={17} isSpan={true}>420mm</SquadSemiBoldText> 宽：<SquadSemiBoldText fontSize={15} lineHeight={17} isSpan={true}>400mm</SquadSemiBoldText> 高：<SquadSemiBoldText fontSize={15} lineHeight={17} isSpan={true}>430mm</SquadSemiBoldText>
                  </PingFangMediumText>
                )
              }
            </div>
          </div>
        )
      }
    </div>
  );
};

export interface Props {
  isEnglish: boolean;
  showQuestion: boolean;
  setShowQuestion: (show: boolean) => void;
}

export default QuestionIcon;
